<template>
  <div class="main-heading">
    <div class="main-heading__title">
      <span class="glicon-user-thin"></span>
      <span>{{ $t('pageTitles.account') }}</span>
      <ul v-if="!$route.meta.hideBreadcrumb" class="breadcrumb-platform">
        <li v-for="(route, index) in $route.matched" :key="index" class="breadcrumb-platform__item">
          <router-link v-if="route.meta.adminName && admin" :to="{ name: route.name }">
            {{ (admin.name ? admin.name : admin.email) + ' ' + (admin.surname || '') }}
          </router-link>
          <router-link v-else :to="{ name: route.name }">
            {{ $t(`breadcrumb.${route.meta.title}`) }}
          </router-link>
          <span class="glicon-double"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'HeadingBar',
  computed: {
    ...mapState({
      admin: (state) => state.admins.admin
    })
  }
};
</script>
